import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../SelectValue/FormikControl";
import Button from "../SelectValue/Button";
import { Link, useNavigate } from "react-router-dom";
import Constant from "../../Constant";
import postService from "../../Services/post-service";
import Loading from "../SelectValue/Loading";
import Logo from "../../Assets/images/Zlogo.png";
import Noticee from "../../Assets/images/notice.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getServices from "../../Services/get-service";
import SelectBank from "../BankCard/SelectBank";
import TextBox from "../SelectValue/TextBox";
function SignupForm() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [datee, setDatee] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [acc, setAcc] = useState("");
  const [accName, setAccName] = useState("");
  const [bvn, setBvn] = useState("");
  const [bName, setBName] = useState("");
  const [loading, setLoading] = useState(false);
  const [identityType, setIdentityType] = useState("");
  const [gender, setGender] = useState("");

  const initialValues = {
    pnumber: "",
    email: "",
    password: "",
    cpassword: "",
  };
  const validationSchema = Yup.object().shape({
    pnumber: Yup.string().matches(
      Constant.phoneRegExp,
      "Phone number is not valid"
    ),
    email: Yup.string().email("Required"),
    password: Yup.string().required("Required"),
    cpassword: Yup.string().when("password", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("password")],
        "Both password need to be the same"
      ),
    }),
  });
  const onSubmit = (values) => {
    setOpen(true);
    const { pnumber, email, password } = values;

    // Check if phone number is exactly 11 digits
    if (pnumber.length !== 11) {
      setOpen(false);
      return toast.error("Phone number must be exactly 11 digits");
    }

    if (gender === "") {
      setOpen(false);
      return toast.error("Please select a gender");
    }

    postService
      .signupUser(
        acc || "",
        bankCode || "",
        bvn || "",
        email,
        pnumber,
        gender,
        password
      )

      .then(
        (response) => {
          setOpen(false);
          if (response.data.statusCode == 200) {
            localStorage.setItem("user", JSON.stringify(response.data.data));
            sessionStorage.setItem("sEmail", email);
            sessionStorage.setItem("sPassword", password); // Save password for verify step
            toast.success("Account created successfully");
            setTimeout(() => {
              navigate("/verifyaccount");
            }, 1500);
          } else {
            toast.error(response.data.description);
          }
        },
        (error) => {
          setOpen(false);
          return toast.error(error.response.data.description);
        }
      );
  };
  const dropdownOptions = [
    { key: "Select an option", value: "" },
    { key: "Male", value: "MALE" },
    { key: "Female", value: "FEMALE" },
  ];
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 16);
  return (
    <div className=" bg-signin-bg min-h-screen">
      <div className="grid h-screen md:h-[90vh] py-7 px-4 place-items-center">
        <Loading open={open} />
        <div className=" w-full md:w-[70%] h-[80vh] overflow-y-auto bg-white shadow-md rounded-[16px] p-5 md:p-10">
          <img
            src={Logo}
            width="152"
            height="40"
            className=" mx-auto"
            alt=" logo"
          />
          <h1 className=" text-[18px] mt-6 text-back-color2 mb-5 md:text-[40px] font-[500]">
            Welcome to Zouse
          </h1>
          <p className=" mb-3 text-[#44474E]">
            Let’s get started with some basic information about you.
          </p>
          <div className="  mt-5">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {(formik) => (
                <Form>
                  {/* <p className=' flex mb-3'><img src={Noticee} className=' text-black inline-block' alt='notice'/> Note: Your names should be similar with your BVN for KYC verification</p> */}
                  <div className=" my-3">
                    <label className=" block mb-2">Select Identity Type</label>
                    <select
                      required
                      className=" w-full p-3 border rounded-md"
                      value={identityType}
                      onChange={(e) => setIdentityType(e.target.value)}
                    >
                      <option value={""}>Select Identity</option>
                      <option value={"bvn"}>BVN</option>
                      <option value={"acc"}> Account number</option>
                    </select>
                  </div>
                  {identityType === "acc" && (
                    <div className=" my-3">
                      <TextBox
                        label="Account number"
                        type="text"
                        value={acc}
                        onChange={setAcc}
                      />
                    </div>
                  )}
                  {identityType === "acc" && (
                    <div className=" my-3">
                      <SelectBank
                        bool={true}
                        value={bankCode}
                        onChange={setBankCode}
                        bName={setBName}
                      />
                    </div>
                  )}

                  <div className=" my-3">
                    <label className=" block mb-2">Select Gender</label>
                    <select
                      required
                      className="w-full p-3 border rounded-md"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                    >
                      <option value={""}>Select Gender</option>
                      <option value={"MALE"}>Male</option>
                      <option value={"FEMALE"}>Female</option>
                    </select>
                  </div>

                  {identityType === "bvn" && (
                    <div className=" my-3">
                      <TextBox
                        label="Bank verification number(BVN)"
                        type="text"
                        value={bvn}
                        onChange={setBvn}
                      />
                    </div>
                  )}

                  <div className=" grid mb-3 md:grid-cols-2 gap-5">
                    <FormikControl
                      control="input"
                      type="tel"
                      label="Phone number"
                      name="pnumber"
                    />
                    <FormikControl
                      control="input"
                      type="email"
                      label="Email address"
                      name="email"
                    />
                  </div>

                  <div className=" grid mb-3 md:grid-cols-2 gap-5">
                    <FormikControl
                      control="password"
                      label="Create password"
                      name="password"
                    />
                    <FormikControl
                      control="password"
                      label="Repeat password"
                      name="cpassword"
                    />
                  </div>

                  <div className=" grid grid-cols-1 mb-5 mt-10">
                    <Button name="Continue" />
                  </div>
                  <div>
                    <p className=" text-center mt-6">
                      Have an account?{" "}
                      <span className=" text-primary-color">
                        <Link to="/">Login</Link>
                      </span>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupForm;
